import { FC } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Divider,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const PaymentSuccess: FC = () => {
  const navigate = useNavigate();

  return (
    <ProfileBorderBox>
       <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, pr: 2 }}>
    
       </Box>
    <Box
      sx={{
     minHeight: "calc(100vh - 64px)", // adjust if you have a header
     display: "flex",
     alignItems: "center",
     justifyContent: "center",
     background: "linear-gradient(to bottom right, #f0f4ff, #e2f0e9)",
     py: 5,
      }}
    >
      <Card
     elevation={6}
     sx={{
       maxWidth: 600,
       width: "100%",
       px: 4,
       py: 5,
       borderRadius: 4,
       textAlign: "center",
       backgroundColor: "#ffffff",
     }}
      >
     <CheckCircle sx={{ fontSize: 72, color: "green", mb: 2 }} />

    <Box width="100%" display="flex" justifyContent="center">
<Typography
    variant="h4"
    fontWeight={600}
    gutterBottom
    align="center"
    sx={{ textAlign: "center", whiteSpace: "nowrap",  }}
>
    Payment&nbsp;Successful
</Typography>
</Box>

     <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
       Thank you! Your payment has been processed successfully.
     </Typography>

     <Divider sx={{ my: 3 }} />

     <Grid container spacing={2} justifyContent="center">
       <Grid item>
         <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/fee/paymentHistory")}
        sx={{ px: 3 }}
             color="primary"
         >
        View Payment History
         </Button>
       </Grid>
     </Grid>
      </Card>
    </Box>
     </ProfileBorderBox>
  );
};

export default PaymentSuccess;
